export default __webpack_public_path__ + "static/media/education.d42b268a.jpg";